<template>
  <div class="circular-timer" :aria-label="`${remaining}초 남음`" role="timer">
    <svg viewBox="0 0 44 44" aria-hidden="true">
      <circle class="circular-timer__track" cx="22" cy="22" r="18" />
      <circle
        class="circular-timer__value"
        cx="22"
        cy="22"
        r="18"
        :style="{ strokeDashoffset: dashOffset }"
      />
    </svg>
    <strong>{{ remaining }}</strong>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'

const props = defineProps<{
  remaining: number
  progress: number
}>()

const circumference = 2 * Math.PI * 18
const dashOffset = computed(() => `${circumference * (1 - props.progress)}`)
</script>
